import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './login/Login';
import Dashboard from './home/Dashboard';
import CalendarView from './home/CalendarView';
import TransactionLedger from './home/TransactionLedger';
import CompanyOverview from './home/CompanyOverview';
import CustomerSupport from './home/CustomerSupport';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/overview" element={<CompanyOverview />} />
        <Route path="/users" element={<Dashboard />} />
        <Route path="/dashboard" element={<Navigate to="/overview" replace />} />
        <Route path="/calendar" element={<CalendarView />} />
        <Route path="/transactions" element={<TransactionLedger />} />
        <Route path="/support" element={<CustomerSupport />} />
      </Routes>
    </Router>
  );
}

export default App;
